import React from "react";
import * as views from "./defaultViews";
import { Cell, Views, DetailsViews } from "./types";

function applyZoom(cell: Cell, zoom: number) {
  return {
    width: cell.width + cell.width * (zoom / 10),
    height: cell.height,
  };
}

function useViews() {
  const [currentView, setCurrentView] = React.useState<Views>(Views.WEEKLY);
  const [detailsView, setDetailsView] = React.useState<DetailsViews>(
    DetailsViews.DATES,
  );
  const [cell, setCell] = React.useState<Cell>(views.weekly);
  const [zoom, setZoom] = React.useState<number>(0);

  return {
    zoom,
    setZoom,

    cell: applyZoom(cell, zoom),
    currentView,

    detailsView,
    areDetailsOpen: false,
    selectDetailsView: (detailsView: DetailsViews) =>
      setDetailsView(detailsView),

    selectView: (currentView: Views) => {
      setCell(
        currentView === Views.DAILY
          ? views.daily
          : currentView === Views.WEEKLY
            ? views.weekly
            : currentView === Views.MONTHLY
              ? views.monthly
              : currentView === Views.YEARLY
                ? views.yearly
                : views.weekly,
      );
      setZoom(0);
      setCurrentView(currentView);
    },
  };
}

export type { Cell };

export { useViews, views, Views, DetailsViews };
export { HOURS_PER_DAY } from "./defaultViews";
